import React from 'react';
export function BrochureSection() {
  return <div className="mb-12 flex justify-center" data-id="element-3648">
      <a href="https://www.peakedm.com/uploaded/files/Seibu/Seibu-Brochure.pdf?direct=1" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-navy text-white px-6 py-3 rounded-lg font-bold text-lg hover:bg-orange transition-colors shadow-md hover:shadow-lg no-underline" data-id="element-3649">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-3650">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" data-id="element-3651" />
          <polyline points="7 10 12 15 17 10" data-id="element-3652" />
          <line x1="12" y1="15" x2="12" y2="3" data-id="element-3653" />
        </svg>
        Download Seibu Product Brochure
      </a>
    </div>;
}